module.exports = __webpack_public_path__ + "media/scripts/pages/join/assets/media/benefits/distribution-chance-02bb6fa35cd450887bfb0730b7df65da.svg";